module.exports = __webpack_public_path__ + "static/img/word.55d9c120.png";